import { useQuery } from '@tanstack/react-query'
import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { parseQueryParams } from '../../utilities/parsers'
import { useAuthStore } from '../../store/authStore'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchTeams = async () => {
  const url = buildUrlWithParams(apiUrl.OUR_TEAM)
  const response = await getData(url)
  return response
}
const fetchUserTeams = async () => {
  const url = buildUrlWithParams(apiUrl.OUR_TEAM_USER)
  const response = await getData(url)
  return response
}

export const useTeamList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['members_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchUserTeams()
      } else {
        return fetchTeams()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}

const fetchMembers = async () => {
  const url = buildUrlWithParams(apiUrl.OUR_MEMBERS)
  const response = await getData(url)
  return response
}
export const useMembersList = () => {
  return useQuery(['members_listing'], () => fetchMembers(), {
    refetchOnWindowFocus: false,
  })
}

const fetchAboutKied = async () => {
  const url = buildUrlWithParams(apiUrl.ABOUT_KIED)
  const response = await getData(url)
  return response
}

const fetchAboutKiedUser = async () => {
  const url = buildUrlWithParams(apiUrl.ABOUT_KIED_USER)
  const response = await getData(url)
  return response
}

export const useAboutkied = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['about_kied_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchAboutKiedUser()
      } else {
        return fetchAboutKied()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
